import { render, staticRenderFns } from "./modal_remark_follow_up.vue?vue&type=template&id=3db4cd7e&"
import script from "./modal_remark_follow_up.vue?vue&type=script&lang=js&"
export * from "./modal_remark_follow_up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports